import DataTable from '@components/table/datatable';
import useDataTable from '@hooks/datatable/useDataTable';
import { UseDisclosureInterface } from '@hooks/useDisclosure';
import { ModalWrapper } from '@hooks/useModal';
import useToast from '@hooks/useToast';
import { selectPOSTableOrdersTotal } from '@modules/point-of-sale/slice/pos-selector';
import { Search } from '@mui/icons-material';
import {
  Button,
  Divider,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useAppSelector } from '@store/index';
import { formatNumber } from '@utils/format';
import { useState } from 'react';

const columns: GridColDef[] = [
  { field: 'accountName', headerName: 'Account Name', flex: 1 },
  { field: 'banquetEvent', headerName: 'Banquet Event', flex: 1 },
];

interface IRow {
  referenceID: number;
  accountName: string;
  banquetEvent: string;
}

const rows: IRow[] = [
  {
    referenceID: 1,
    accountName: 'Servo',
    banquetEvent: 'Test',
  },
  {
    referenceID: 2,
    accountName: 'Servo',
    banquetEvent: 'Test',
  },
  {
    referenceID: 3,
    accountName: 'Servo',
    banquetEvent: 'Test',
  },
  {
    referenceID: 4,
    accountName: 'Servo',
    banquetEvent: 'Test',
  },
];

const POSChargeToAccountModal = ({
  modalDisclosure,
}: {
  modalDisclosure: UseDisclosureInterface;
}) => {
  const { toast } = useToast();
  const [selectedRow, setSelectedRow] = useState<IRow>();
  const [searchValue, setSearchValue] = useState('');
  const { apiRef, handleSearchValueChange } = useDataTable();

  const total = useAppSelector(selectPOSTableOrdersTotal);

  const handleClose = () => {
    modalDisclosure.onClose();
    setTimeout(() => {
      setSelectedRow(undefined);
      setSearchValue('');
    }, 100);
  };

  const handleSave = () => {
    toast({ message: 'No API Message' });
    handleClose();
  };

  return (
    <ModalWrapper
      {...{
        modalDisclosure,
        withHeader: {
          title: `Select Guest Room:`,
          onClose: handleClose,
        },
      }}
    >
      <Stack sx={{ flex: 1, minHeight: 0 }}>
        {/* CONTENT */}
        <Stack gap={3} sx={{ flex: 1, minHeight: 0 }}>
          {/* CARD */}
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            divider={<Divider orientation='vertical' flexItem />}
            gap={2}
            sx={{
              width: '100%',
              '.card': {
                flex: 1,
                minWidth: { xs: '300px', md: '200px' },
              },
              '.card-title': {
                color: '#637381',
              },
              '.card-info': {
                fontWeight: 500,
                fontSize: '22px',
              },
            }}
          >
            <Stack className='card'>
              <Typography className='card-title'>Account Name</Typography>
              <Typography className='card-info'>
                {selectedRow?.accountName ?? '-'}
              </Typography>
            </Stack>
            <Stack className='card'>
              <Typography className='card-title'>Total Amount</Typography>
              <Typography className='card-info'>
                {formatNumber(total, 2, 2)}
              </Typography>
            </Stack>
          </Stack>

          {/* SEARCH */}
          <TextField
            value={searchValue}
            size='small'
            placeholder='Search . . .'
            InputProps={{
              endAdornment: (
                <InputAdornment position='start'>
                  <Search sx={{ color: '#212121' }} />
                </InputAdornment>
              ),
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleSearchValueChange(e, setSearchValue)
            }
            // disabled={isLoading || isFetching}
          />

          {/* DATATABLE */}
          <DataTable
            apiRef={apiRef}
            getRowId={(row) => row.referenceID}
            columns={columns}
            rows={rows}
            sx={{ p: 0, '.MuiDataGrid-selectedRowCount': { display: 'none' } }}
            checkboxSelection={false}
            rowSelectionModel={selectedRow ? [selectedRow?.referenceID] : []}
            onRowClick={(data) =>
              setSelectedRow((prev) =>
                prev?.referenceID === data.row.referenceID
                  ? undefined
                  : data.row,
              )
            }
            disableSearch
            disableColumnFilter
            disableColumnSelector
            fullHeight
            tableStyle={{
              padding: 0,
              height: 'unset',
            }}
            wrapperStyle={{
              height: 'unset',
              display: 'flex',
              flex: 1,
              minHeight: 0,
            }}
          />
        </Stack>

        {/* BUTTON */}
        <Stack
          direction='row'
          gap={2}
          sx={{
            position: 'sticky',
            bottom: 0,
            bgcolor: '#FFF',
            justifyContent: 'flex-end',
            borderTop: '1px solid #EEE',
            pt: 3,
          }}
        >
          <Button variant='outlined' onClick={handleClose}>
            Close
          </Button>
          <Button
            variant='contained'
            disabled={!selectedRow}
            onClick={handleSave}
          >
            Save
          </Button>
        </Stack>
      </Stack>
    </ModalWrapper>
  );
};

export default POSChargeToAccountModal;
